import { SvgIconProps } from "@material-ui/core";
import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export interface IconProps extends SvgIconProps {
  disable?: boolean;
}

export default (props: IconProps) => {
  const { disable, ...restProps } = props;
  const CheckboxChecked = createSvgIcon(
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="16"
        height="16"
        rx="4"
        fill={disable ? "#999999" : "#009FB8"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1754 3.76258C12.5827 4.13561 12.6105 4.76817 12.2374 5.17544C11.0843 6.43437 10.5299 7.20192 9.69701 8.69219C9.38256 9.25484 9.0343 10.0352 8.75672 10.699C8.62 11.026 8.50411 11.3157 8.42249 11.5235C8.38173 11.6273 8.34962 11.7104 8.32786 11.7671L8.30323 11.8316L8.29714 11.8476L8.29573 11.8514C8.17161 12.1812 7.88277 12.4221 7.53594 12.4843C7.18908 12.5465 6.83511 12.4215 6.60417 12.1554L3.74469 8.85969C3.38275 8.44254 3.42751 7.81096 3.84466 7.44901C4.26182 7.08707 4.8934 7.13183 5.25534 7.54898L7.04513 9.61179C7.30929 8.99536 7.63434 8.28338 7.95116 7.71649C8.85954 6.0911 9.50494 5.19765 10.7626 3.82457C11.1356 3.41731 11.7682 3.38955 12.1754 3.76258Z"
        fill="white"
      />
    </svg>,
    "CheckboxChecked"
  );
  return <CheckboxChecked {...restProps} viewBox="0 0 16 16" />;
};
